import { Component } from '../base/Components';
import { createElement, ensureElement } from '../../utils/utils';
export class Basket extends Component {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._list = ensureElement('.basket__list', this.container);
        this._total = this.container.querySelector('.basket__price');
        this._button = this.container.querySelector('.basket__button');
        if (this._button) {
            this._button.addEventListener('click', () => {
                events.emit('order:open');
            });
        }
        this.items = [];
    }
    set items(items) {
        if (items.length) {
            this._list.replaceChildren(...items);
        }
        else {
            this._list.replaceChildren(createElement('p', {
                textContent: 'Корзина пуста',
            }));
            this.setDisabled(this._button, true);
        }
    }
    set total(total) {
        this.setText(this._total, `${total} синапсов`);
        this.setDisabled(this._button, total === 0);
    }
}
